import{createHtmlRenderState as t}from"../../html/utils/create-render-state.mjs.js";const r=()=>({...t(),attrs:{}});export{r as createSvgRenderState};
